import { render, staticRenderFns } from "./VCostsBudgetReport.vue?vue&type=template&id=1b6ea945&"
import script from "./VCostsBudgetReport.vue?vue&type=script&lang=js&"
export * from "./VCostsBudgetReport.vue?vue&type=script&lang=js&"
import style0 from "./VCostsBudgetReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports